module.exports = __webpack_public_path__ + "img/banner1.28c98b2b.png";